/**
 * Pure permission check used by nav, route gates, and the role-nav golden
 * test. Kept free of zustand / DOM so Node can import it.
 *
 * Backend PermCode format (see backend/internal/domain/actor.go):
 *   "resource.action@<schoolUUID>"  — school-scoped
 *   "resource.action@*"             — org-wide
 *
 * Also accepts a bare "resource.action", "@*" (all org-wide), and "*.*@*"
 * (super-admin wildcard).
 */
export function hasPermission(
  permissions: string[],
  resource: string,
  action: string,
  schoolId?: string,
): boolean {
  const code = `${resource}.${action}`;

  if (permissions.includes('@*') || permissions.includes('*.*@*')) return true;
  if (permissions.includes(code)) return true;
  if (permissions.includes(`${code}@*`)) return true;
  if (schoolId && permissions.includes(`${code}@${schoolId}`)) return true;
  // After login the school switcher may not have resolved an id yet. Any
  // held scope of this code (org-wide or a concrete school) is enough to
  // show the sidebar item; a later schoolId still narrows the check.
  if (!schoolId) {
    const prefix = `${code}@`;
    if (permissions.some((held) => held.startsWith(prefix))) return true;
  }

  return false;
}
